module.exports = __webpack_public_path__ + "c697da0b.png";